import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { CrudType } from "@core/enums/crud-type";
import { ETaxRuleType } from "@core/enums/tax-rule-type";
import { TaxRule } from "@core/models/tax-rule.model";
import { WithholdingConfig } from "@core/models/withholding-config.model";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SettingsService {
  constructor(private http: HttpClient) {}

  getTaxRuleList$(
    year?: number,
    taxRuleType?: ETaxRuleType
  ): Observable<Array<TaxRule>> {
    if (year && taxRuleType !== undefined) {
      let params = new HttpParams().set("year", year);
      params = params.append("type", taxRuleType);
      return this.http.get<Array<TaxRule>>(
        `${environment.BASE_URL}taxrule/TaxYear`,
        { params }
      );
    }
    return this.http.get<Array<TaxRule>>(
      `${environment.BASE_URL}taxrule/GetAll`
    );
  }

  getWithholdingConfigList$(
    year?: number
  ): Observable<Array<WithholdingConfig>> {
    if (year) {
      const params = new HttpParams().set("year", year);
      return this.http.get<Array<WithholdingConfig>>(
        `${environment.BASE_URL}withholdingconfig/Year`,
        {
          params,
        }
      );
    }
    return this.http.get<Array<WithholdingConfig>>(
      `${environment.BASE_URL}withholdingconfig/GetAll`
    );
  }

  saveTaxRule$(taxRule: Partial<TaxRule>, id?: string): Observable<unknown> {
    return this.http[id ? CrudType.Put : CrudType.Post](
      `${environment.BASE_URL}taxrule/`,
      taxRule
    );
  }

  saveWithholdingConfig$(
    withholdingConfig: Partial<WithholdingConfig>,
    id?: string
  ): Observable<unknown> {
    return this.http[id ? CrudType.Put : CrudType.Post](
      `${environment.BASE_URL}withholdingconfig/`,
      withholdingConfig
    );
  }
}
